'use client';

import { useMemo } from 'react';
import { UrqlProvider, ssrExchange, cacheExchange, fetchExchange, createClient } from '@urql/next';

/** @deprecated use GqlProviderWithGraphache */
export const GqlProvider = ({ children }: React.PropsWithChildren) => {
  const [client, ssr] = useMemo(() => {
    const ssrEx = ssrExchange();
    const urqlClient = createClient({
      url:
        process.env.GQL_GATEWAY ??
        `${typeof window === 'undefined' ? process.env.SERVER_HOST : ''}/api/gateway/`,
      exchanges: [cacheExchange, ssrEx, fetchExchange],
      suspense: true,
    });

    return [urqlClient, ssrEx];
  }, []);

  return (
    <UrqlProvider client={client} ssr={ssr}>
      {children}
    </UrqlProvider>
  );
};
